import {initializeApp, FirebaseApp} from "firebase/app";
import {getAuth, Auth} from "firebase/auth";
import {apiKey, authDomain} from "./dom";

const firebaseConfig = {
    apiKey: apiKey,
    authDomain: authDomain,
};

const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);